// Helpers to get viewport dimensions.
// These methods try to handle different edge cases as described in https://stackoverflow.com/a/8876069

export function getViewportHeight(): number {
    return Math.max(window.document.documentElement.clientHeight, window.innerHeight || 0);
}

export function getViewportWidth(): number {
    return Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0);
}

export enum WidthPresets {
    phoneMax = 576,
    normalPhoneMin = 400,
    tabletMin = 577,
    desktopMin = 769,
    mediumDesktopMin = 993,
    bigDesktopMin = 1025,
    xxlDesktopMin = 1441
}
